import { Box, Button, Chip, Divider, Grid, Typography } from "../../imports/muiImport";
import { NavLink } from 'react-router-dom';
import { titleToUrl } from '../../shared/extra';
import moment from 'moment';
import { defaultBlogImage } from "../../imports/generalImport";

const getPreviewText = (htmlContent, maxLength = 150) => {
    if (!htmlContent) return "";
    const plainText = htmlContent.replace(/<[^>]+>/g, "");
    return plainText.length > maxLength
        ? plainText.slice(0, maxLength) + "..."
        : plainText;
};

const formattedDate = (createdAt) => moment(createdAt).format("MMM DD, YYYY"); // e.g., "Mar 26, 2022"

const BlogCard = ({ data }) => {
    return (
        <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box
                sx={{
                    border: 1.5,
                    borderColor: "borderColor.main",
                    height: { sm: 443, },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    p: 1,
                    borderRadius: 2,
                    boxShadow: 3,
                }}
            >
                <Box
                    component="img"
                    src={data?.posterImage || defaultBlogImage}
                    alt="Blog"
                    loading="lazy"
                    sx={{
                        width: "100%",
                        height: "100%",
                        maxHeight: {
                            lg: 210,
                            xl: 'auto'
                        },
                        objectFit: "cover",
                        borderRadius: 2,
                        mb: 2,
                        boxShadow: 4,
                    }}
                />

                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 1 }}>
                    {data?.updated_at &&
                        <Chip
                            label={formattedDate(data?.updated_at)}
                            size="small"
                            sx={{
                                fontSize: "11px",
                                backgroundColor: "lightSecondary.main",
                                color: "black",
                                fontWeight: 500,
                                px: 0.5,
                                borderRadius: 1,
                                boxShadow: 1
                            }}
                        />

                    }

                    {data?.categroies &&
                        <>
                            <Divider
                                orientation="vertical"
                                flexItem
                                sx={{
                                    borderColor: 'lightSecondary.main',
                                }}
                            />

                            <Chip
                            label={data?.categroies
                                }
                                size="small"
                                sx={{
                                    fontSize: "11px",
                                    backgroundColor: "lightSecondary.main",
                                    color: "black",
                                    fontWeight: 500,
                                    px: 0.5,
                                    borderRadius: 1,
                                    boxShadow: 1
                                }}
                            />
                        </>
                    }
                </Box>


                {/* Blog Content */}
                <NavLink
                    to={`/blog-details/${titleToUrl(data?.title)}`}
                    style={{ textDecoration: "none" }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            color: "dark.main",
                            fontSize: { xs: "18px", md: "17.5px" },
                            fontWeight: 500,
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: { xs: "24px", md: "2rem" },
                            mb: 1,
                        }}
                    >
                        {data?.title}
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontSize: { xs: "14px", md: "13.5px" },
                            lineHeight: { xs: "20px", md: "22px" },
                            fontWeight: { xs: 300, md: 500 },
                            color: "textPrimary.main",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            mb: 2,
                        }}
                    >
                        {getPreviewText(data?.content)}
                    </Typography>
                </NavLink>

                {/* Read More Button */}
                <Box>
                    <NavLink
                        to={`/blog-details/${titleToUrl(data?.title)}`}
                        style={{ textDecoration: "none" }}
                    >
                        <Button
                            variant="outlined"
                            sx={{
                                fontSize: "12px",
                                color: "white.main",
                                backgroundColor: "black",
                                textTransform: "none",
                                px: 3,
                                ":hover": {
                                    backgroundColor: "grey.800",
                                },
                            }}
                        >
                            Read More
                        </Button>
                    </NavLink>
                </Box>
            </Box>
        </Grid>
    )
}

export default BlogCard